import React, { PropTypes } from 'react';
import ReputationChart from 'common/components/reputation_chart';

const Stats = ({
  reputation, projects_participated, projects_won, projects_runnerup, is_creative,
  is_elite, is_platinum,
}) => {
  const reputationInt = parseInt(reputation, 10);
  const eliteLabel = is_elite ? 'Elite' : '';
  const platinumLabel = is_platinum ? 'Platinum' : '';
  const reputationLabel = eliteLabel || platinumLabel;

  return (
          <div className="profile-stats">
            <div className="row">
              <div className="column small-4 medium-4">
                { reputationLabel && <span className="tag tag-highlight tag-sm">
                  { reputationLabel }
                </span> }
                { !reputationLabel && <label htmlFor="project-number">Reputation</label> }
                <ReputationChart className="reputation" reputation={reputationInt} />
              </div>
              <div className="column small-4 medium-4">
                <label htmlFor="project-number">Projects</label>
                <div className="project-number">{projects_participated}</div>
              </div>
              <div className="column small-4 medium-4">
                <label htmlFor="project-number">Wins</label>
                <div className="project-number">{projects_won}</div>
              </div>
              <div className="column small-4 medium-4">
                <label htmlFor="project-number">Finalist</label>
                <div className="project-number">{projects_runnerup}</div>
              </div>
            </div>
          </div>
        );
};

Stats.propTypes = {
  reputation: PropTypes.number,
  projects_participated: PropTypes.number,
  projects_won: PropTypes.number,
  projects_runnerup: PropTypes.number,
  is_creative: PropTypes.bool,
  is_elite: PropTypes.bool,
  is_platinum: PropTypes.bool,
};

export default Stats;



// WEBPACK FOOTER //
// ./profile/components/stats.jsx